import { gsap, TweenMax } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import ScrollMagicFn from '@/utils/ScrollMagic';
import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';

gsap.registerPlugin(ScrollTrigger);

export default function XstreamPC() {
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax);
    }

    return (
        <div className={`xstream ${css.xstream}`}>
            <A />
            <B />
            <C />
            <D />
            <E />
        </div>
    );
}
